import styled, { css, keyframes } from 'styled-components';

// TODO: 여기 싹 다 뜯어 고 쳐 야 함
export const FloatingBoxWrap = styled.div<{ status?: boolean }>`
  height: 95px;
`;

export const FloatingBox = styled.div<{ status?: boolean }>`
  ${(props) => (props.status ? `bottom: -195px` : `bottom: 0`)};
  transition: bottom 0.2s;
  padding: 20px 20px 40px;
  position: fixed;
  width: 100vw;
  box-sizing: border-box;
  z-index: 99;
`;

export const FloatinArea = styled.div`
  position: relative;
`;

export const FloatingFlexBox = styled.div<{ status?: boolean }>`
  ${(props) => (props.status ? `bottom: -95px` : `bottom: 0`)};
  transition: bottom 0.2s;
  padding: 0 20px 20px 20px;
  position: fixed;
  width: 100vw;
  box-sizing: border-box;
  z-index: 99;
  display: flex;
  justify-content: space-between;
`;

export const FlexBox = styled.div<{
  padding?: string;
  justify?: string;
  alignItems?: string;
}>`
  display: flex;
  width: 100%;
  box-sizing: border-box;

  ${(props) => props.padding && `padding: ${props.padding};`}
  ${(props) =>
    props.justify &&
    `
  justify-content: ${props.justify};
  `}
  align-items: ${(props) => props.alignItems ?? 'center'};
`;

// todo oui 변경 필요
export const FlexBox2 = styled.div`
  display: flex;
  width: 100%;
`;

export const ScrollXBox = styled.div`
  overflow-x: auto;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
`;

export const RecordBox = styled.div`
  width: 100%;
  height: 171px;
  box-sizing: border-box;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 20px;
`;

export const DefaultBox = styled.div<{ verticalGap?: number }>`
  padding: ${({ verticalGap }) => verticalGap || 20}px 20px;
`;

export const ListWithGap = styled.div<{ gap?: number }>`
  padding: 0 20px 20px;

  > *:not(:last-child) {
    margin-bottom: ${({ gap }) => gap ?? 10}px;
  }
`;

export const CtaBoxWrap = styled.div<{
  twoButton: boolean;
}>`
  ${(props) =>
    props.twoButton ? 'width: 50%; padding: 20px 0px;' : 'padding: 20px;'}
`;

export const SegmentBox = styled.div<{ gap?: number }>`
  display: flex;
  align-items: center;

  > *:not(:last-child) {
    margin-right: ${({ gap }) => gap || 12}px;
  }
`;

export const SideBox = styled.div<{
  topDownAnimation?: boolean;
  padding?: string;
}>`
  padding: ${({ padding }) => padding || '0 20px'};
  ${({ topDownAnimation }) =>
    topDownAnimation &&
    css`
      animation: ${topDown} 0.3s ease-in-out;
    `}
`;

export const BannerBox = styled.div`
  padding: 20px;
  background: #fff;

  > img {
    width: 100%;
  }
`;

export const CenterBox = styled.div`
  padding: 20px;
  display: flex;
  justify-content: center;
`;

export const AlignBox = styled.div`
  padding: 20px;
  align-items: center;
  text-align: center;
  margin: 0 auto;
`;

export const GridBox = styled.div<{ topDownAnimation?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  ${({ topDownAnimation }) =>
    topDownAnimation &&
    css`
      margin-top: 10px;
      animation: ${topDown} 0.3s ease-in-out;
    `}
  grid-gap: 10px 6px;

  > * {
    flex: 1 1 45%;
  }
`;

export const TimerBox = styled.div`
  display: flex;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #9c9c9c;
  margin-top: 4px;

  > p {
    margin-right: 4px;
  }
`;

export const MainImageBox = styled.div`
  overflow-x: hidden;
  height: 500px;
  position: relative;

  > img {
    position: absolute;
    left: 50%;
    height: 100%;
    width: auto;
    min-width: 100%;
    transform: translateX(-50%);
  }
`;

export const VisualBox = styled.div`
  > img {
    width: 100%;
  }
`;

export const WithFloationgBox = styled.div`
  height: 115px;
`;

export const Height60 = styled.div`
  min-height: 60px;
`;

export const IconBox = styled.div<{ padding: string }>`
  padding: ${(props) => props.padding};
`;

export const GridBox2 = styled.div<{ repeat: number }>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.repeat}, 1fr);
  padding: 20px 0;
`;

export const ListBox = styled.div<{ gap: number; padding: string }>`
  padding: ${(props) => props.padding};

  > div + div {
    margin-top: ${(props) => props.gap}px;
  }
`;

export const FooterSpace = styled.div`
  height: 100px;
  background-color: #f7f7f7;
`;

const topDown = keyframes`
  from {
    transform: translateY(-10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;
